/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import Fade from 'react-reveal/Fade';
import icon1 from 'assets/images/str2.svg';
import icon2 from 'assets/images/str1.svg';
import icon3 from 'assets/images/str3.svg';
import backgroundImage from 'assets/images/background.svg';
import backgroundImage1 from 'assets/images/back1.svg';

export default function AboutDetail() {
  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right',
  };
  const backgroundStyle2 = {
    backgroundImage: `url(${backgroundImage1})`,
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'left',
  };
  return (
    <>
      <div className="container mx-auto pt-1 pb-10">
        <div className="flex flex-wrap">
          <div className="w-full p-4">
            <div className="bg-primary-color text-white py-10 px-10 md:px-20 rounded-lg" style={backgroundStyle}>
              <div className="w-full lg:w-1/2">
                <h2 className="text-4xl font-bold mb-4">Achieve Success with VexaTech</h2>
                <p>
                  Our expert team is dedicated to crafting immersive digital
                  experiences that drive exceptional growth. We anticipate industry
                  trends, harness data insights, and provide transformative solutions
                  to unlock your online potential and ensure sustainable business
                  growth. Partner with us to stay at the forefront of the digital revolution.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="services-bg">
        <div className="container mx-auto pt-10 pb-10 services-bg" style={backgroundStyle2}>
          <Fade bottom>
            <h1 className="text-3xl text-theme-blue text-center font-bold">Achieve Success with VexaTech</h1>
          </Fade>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-y-8 gap-x-32 sm:gap-14 lg:gap-10 mx-16 justify-items-center">
            <div className="flex flex-col items-center justify-center w-44 sm:w-56 h-60 sm:h-72 rounded-xl transform transition duration-500 hover:scale-105">
              <div className="rounded-full icon-bg w-32 h-32 flex items-center justify-center mb-3">
                <img src={icon1} alt="Team Member" className="w-12 h-12" />
              </div>
              <h5 className="text-theme-blue text-center text-xl">Great Experience</h5>
            </div>
            <div className="flex flex-col items-center justify-center w-44 sm:w-56 h-60 sm:h-72 rounded-xl transform transition duration-500 hover:scale-105">
              <div className="rounded-full icon-bg w-32 h-32 flex items-center justify-center mb-3">
                <img src={icon2} alt="Team Member" className="w-12 h-12" />
              </div>
              <h5 className="text-theme-blue text-center text-xl">Effective Statigy</h5>
            </div>
            <div className="flex flex-col items-center justify-center w-44 sm:w-56 h-60 sm:h-72 rounded-xl transform transition duration-500 hover:scale-105">
              <div className="rounded-full icon-bg w-32 h-32 flex items-center justify-center mb-3">
                <img src={icon3} alt="Team Member" className="w-12 h-12" />
              </div>
              <h5 className="text-theme-blue text-center text-xl">Unique Solutions</h5>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
